// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__14TbJ","header":"MessagesList_header__3A0IJ","chat":"MessagesList_chat__1oNdT"};